import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class IPHelper {
    private httpClient: HttpClient;
    constructor(private handler: HttpBackend) {
        this.httpClient = new HttpClient(handler);
    }

    getClientIP() {
        return this.httpClient.get<any>('https://jsonip.com');
    }
}
